module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2012-10-25",
		"endpointPrefix": "directconnect",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceFullName": "AWS Direct Connect",
		"signatureVersion": "v4",
		"targetPrefix": "OvertureService",
		"uid": "directconnect-2012-10-25"
	},
	"operations": {
		"AllocateConnectionOnInterconnect": {
			"input": {
				"type": "structure",
				"required": [
					"bandwidth",
					"connectionName",
					"ownerAccount",
					"interconnectId",
					"vlan"
				],
				"members": {
					"bandwidth": {},
					"connectionName": {},
					"ownerAccount": {},
					"interconnectId": {},
					"vlan": {
						"type": "integer"
					}
				}
			},
			"output": {
				"shape": "S7"
			},
			"deprecated": true
		},
		"AllocateHostedConnection": {
			"input": {
				"type": "structure",
				"required": [
					"connectionId",
					"ownerAccount",
					"bandwidth",
					"connectionName",
					"vlan"
				],
				"members": {
					"connectionId": {},
					"ownerAccount": {},
					"bandwidth": {},
					"connectionName": {},
					"vlan": {
						"type": "integer"
					}
				}
			},
			"output": {
				"shape": "S7"
			}
		},
		"AllocatePrivateVirtualInterface": {
			"input": {
				"type": "structure",
				"required": [
					"connectionId",
					"ownerAccount",
					"newPrivateVirtualInterfaceAllocation"
				],
				"members": {
					"connectionId": {},
					"ownerAccount": {},
					"newPrivateVirtualInterfaceAllocation": {
						"type": "structure",
						"required": [
							"virtualInterfaceName",
							"vlan",
							"asn"
						],
						"members": {
							"virtualInterfaceName": {},
							"vlan": {
								"type": "integer"
							},
							"asn": {
								"type": "integer"
							},
							"authKey": {},
							"amazonAddress": {},
							"addressFamily": {},
							"customerAddress": {}
						}
					}
				}
			},
			"output": {
				"shape": "Sp"
			}
		},
		"AllocatePublicVirtualInterface": {
			"input": {
				"type": "structure",
				"required": [
					"connectionId",
					"ownerAccount",
					"newPublicVirtualInterfaceAllocation"
				],
				"members": {
					"connectionId": {},
					"ownerAccount": {},
					"newPublicVirtualInterfaceAllocation": {
						"type": "structure",
						"required": [
							"virtualInterfaceName",
							"vlan",
							"asn"
						],
						"members": {
							"virtualInterfaceName": {},
							"vlan": {
								"type": "integer"
							},
							"asn": {
								"type": "integer"
							},
							"authKey": {},
							"amazonAddress": {},
							"customerAddress": {},
							"addressFamily": {},
							"routeFilterPrefixes": {
								"shape": "Sv"
							}
						}
					}
				}
			},
			"output": {
				"shape": "Sp"
			}
		},
		"AssociateConnectionWithLag": {
			"input": {
				"type": "structure",
				"required": [
					"connectionId",
					"lagId"
				],
				"members": {
					"connectionId": {},
					"lagId": {}
				}
			},
			"output": {
				"shape": "S7"
			}
		},
		"AssociateHostedConnection": {
			"input": {
				"type": "structure",
				"required": [
					"connectionId",
					"parentConnectionId"
				],
				"members": {
					"connectionId": {},
					"parentConnectionId": {}
				}
			},
			"output": {
				"shape": "S7"
			}
		},
		"AssociateVirtualInterface": {
			"input": {
				"type": "structure",
				"required": [
					"virtualInterfaceId",
					"connectionId"
				],
				"members": {
					"virtualInterfaceId": {},
					"connectionId": {}
				}
			},
			"output": {
				"shape": "Sp"
			}
		},
		"ConfirmConnection": {
			"input": {
				"type": "structure",
				"required": [
					"connectionId"
				],
				"members": {
					"connectionId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"connectionState": {}
				}
			}
		},
		"ConfirmPrivateVirtualInterface": {
			"input": {
				"type": "structure",
				"required": [
					"virtualInterfaceId",
					"virtualGatewayId"
				],
				"members": {
					"virtualInterfaceId": {},
					"virtualGatewayId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"virtualInterfaceState": {}
				}
			}
		},
		"ConfirmPublicVirtualInterface": {
			"input": {
				"type": "structure",
				"required": [
					"virtualInterfaceId"
				],
				"members": {
					"virtualInterfaceId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"virtualInterfaceState": {}
				}
			}
		},
		"CreateBGPPeer": {
			"input": {
				"type": "structure",
				"members": {
					"virtualInterfaceId": {},
					"newBGPPeer": {
						"type": "structure",
						"members": {
							"asn": {
								"type": "integer"
							},
							"authKey": {},
							"addressFamily": {},
							"amazonAddress": {},
							"customerAddress": {}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"virtualInterface": {
						"shape": "Sp"
					}
				}
			}
		},
		"CreateConnection": {
			"input": {
				"type": "structure",
				"required": [
					"location",
					"bandwidth",
					"connectionName"
				],
				"members": {
					"location": {},
					"bandwidth": {},
					"connectionName": {},
					"lagId": {}
				}
			},
			"output": {
				"shape": "S7"
			}
		},
		"CreateInterconnect": {
			"input": {
				"type": "structure",
				"required": [
					"interconnectName",
					"bandwidth",
					"location"
				],
				"members": {
					"interconnectName": {},
					"bandwidth": {},
					"location": {},
					"lagId": {}
				}
			},
			"output": {
				"shape": "S1j"
			}
		},
		"CreateLag": {
			"input": {
				"type": "structure",
				"required": [
					"numberOfConnections",
					"location",
					"connectionsBandwidth",
					"lagName"
				],
				"members": {
					"numberOfConnections": {
						"type": "integer"
					},
					"location": {},
					"connectionsBandwidth": {},
					"lagName": {},
					"connectionId": {}
				}
			},
			"output": {
				"shape": "S1o"
			}
		},
		"CreatePrivateVirtualInterface": {
			"input": {
				"type": "structure",
				"required": [
					"connectionId",
					"newPrivateVirtualInterface"
				],
				"members": {
					"connectionId": {},
					"newPrivateVirtualInterface": {
						"type": "structure",
						"required": [
							"virtualInterfaceName",
							"vlan",
							"asn",
							"virtualGatewayId"
						],
						"members": {
							"virtualInterfaceName": {},
							"vlan": {
								"type": "integer"
							},
							"asn": {
								"type": "integer"
							},
							"authKey": {},
							"amazonAddress": {},
							"customerAddress": {},
							"addressFamily": {},
							"virtualGatewayId": {}
						}
					}
				}
			},
			"output": {
				"shape": "Sp"
			}
		},
		"CreatePublicVirtualInterface": {
			"input": {
				"type": "structure",
				"required": [
					"connectionId",
					"newPublicVirtualInterface"
				],
				"members": {
					"connectionId": {},
					"newPublicVirtualInterface": {
						"type": "structure",
						"required": [
							"virtualInterfaceName",
							"vlan",
							"asn"
						],
						"members": {
							"virtualInterfaceName": {},
							"vlan": {
								"type": "integer"
							},
							"asn": {
								"type": "integer"
							},
							"authKey": {},
							"amazonAddress": {},
							"customerAddress": {},
							"addressFamily": {},
							"routeFilterPrefixes": {
								"shape": "Sv"
							}
						}
					}
				}
			},
			"output": {
				"shape": "Sp"
			}
		},
		"DeleteBGPPeer": {
			"input": {
				"type": "structure",
				"members": {
					"virtualInterfaceId": {},
					"asn": {
						"type": "integer"
					},
					"customerAddress": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"virtualInterface": {
						"shape": "Sp"
					}
				}
			}
		},
		"DeleteConnection": {
			"input": {
				"type": "structure",
				"required": [
					"connectionId"
				],
				"members": {
					"connectionId": {}
				}
			},
			"output": {
				"shape": "S7"
			}
		},
		"DeleteInterconnect": {
			"input": {
				"type": "structure",
				"required": [
					"interconnectId"
				],
				"members": {
					"interconnectId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"interconnectState": {}
				}
			}
		},
		"DeleteLag": {
			"input": {
				"type": "structure",
				"required": [
					"lagId"
				],
				"members": {
					"lagId": {}
				}
			},
			"output": {
				"shape": "S1o"
			}
		},
		"DeleteVirtualInterface": {
			"input": {
				"type": "structure",
				"required": [
					"virtualInterfaceId"
				],
				"members": {
					"virtualInterfaceId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"virtualInterfaceState": {}
				}
			}
		},
		"DescribeConnectionLoa": {
			"input": {
				"type": "structure",
				"required": [
					"connectionId"
				],
				"members": {
					"connectionId": {},
					"providerName": {},
					"loaContentType": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"loa": {
						"shape": "S28"
					}
				}
			},
			"deprecated": true
		},
		"DescribeConnections": {
			"input": {
				"type": "structure",
				"members": {
					"connectionId": {}
				}
			},
			"output": {
				"shape": "S2b"
			}
		},
		"DescribeConnectionsOnInterconnect": {
			"input": {
				"type": "structure",
				"required": [
					"interconnectId"
				],
				"members": {
					"interconnectId": {}
				}
			},
			"output": {
				"shape": "S2b"
			},
			"deprecated": true
		},
		"DescribeHostedConnections": {
			"input": {
				"type": "structure",
				"required": [
					"connectionId"
				],
				"members": {
					"connectionId": {}
				}
			},
			"output": {
				"shape": "S2b"
			}
		},
		"DescribeInterconnectLoa": {
			"input": {
				"type": "structure",
				"required": [
					"interconnectId"
				],
				"members": {
					"interconnectId": {},
					"providerName": {},
					"loaContentType": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"loa": {
						"shape": "S28"
					}
				}
			},
			"deprecated": true
		},
		"DescribeInterconnects": {
			"input": {
				"type": "structure",
				"members": {
					"interconnectId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"interconnects": {
						"type": "list",
						"member": {
							"shape": "S1j"
						}
					}
				}
			}
		},
		"DescribeLags": {
			"input": {
				"type": "structure",
				"members": {
					"lagId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"lags": {
						"type": "list",
						"member": {
							"shape": "S1o"
						}
					}
				}
			}
		},
		"DescribeLoa": {
			"input": {
				"type": "structure",
				"required": [
					"connectionId"
				],
				"members": {
					"connectionId": {},
					"providerName": {},
					"loaContentType": {}
				}
			},
			"output": {
				"shape": "S28"
			}
		},
		"DescribeLocations": {
			"output": {
				"type": "structure",
				"members": {
					"locations": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"locationCode": {},
								"locationName": {}
							}
						}
					}
				}
			}
		},
		"DescribeTags": {
			"input": {
				"type": "structure",
				"required": [
					"resourceArns"
				],
				"members": {
					"resourceArns": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"resourceTags": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"resourceArn": {},
								"tags": {
									"shape": "S2x"
								}
							}
						}
					}
				}
			}
		},
		"DescribeVirtualGateways": {
			"output": {
				"type": "structure",
				"members": {
					"virtualGateways": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"virtualGatewayId": {},
								"virtualGatewayState": {}
							}
						}
					}
				}
			}
		},
		"DescribeVirtualInterfaces": {
			"input": {
				"type": "structure",
				"members": {
					"connectionId": {},
					"virtualInterfaceId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"virtualInterfaces": {
						"type": "list",
						"member": {
							"shape": "Sp"
						}
					}
				}
			}
		},
		"DisassociateConnectionFromLag": {
			"input": {
				"type": "structure",
				"required": [
					"connectionId",
					"lagId"
				],
				"members": {
					"connectionId": {},
					"lagId": {}
				}
			},
			"output": {
				"shape": "S7"
			}
		},
		"TagResource": {
			"input": {
				"type": "structure",
				"required": [
					"resourceArn",
					"tags"
				],
				"members": {
					"resourceArn": {},
					"tags": {
						"shape": "S2x"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"UntagResource": {
			"input": {
				"type": "structure",
				"required": [
					"resourceArn",
					"tagKeys"
				],
				"members": {
					"resourceArn": {},
					"tagKeys": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"UpdateLag": {
			"input": {
				"type": "structure",
				"required": [
					"lagId"
				],
				"members": {
					"lagId": {},
					"lagName": {},
					"minimumLinks": {
						"type": "integer"
					}
				}
			},
			"output": {
				"shape": "S1o"
			}
		}
	},
	"shapes": {
		"S7": {
			"type": "structure",
			"members": {
				"ownerAccount": {},
				"connectionId": {},
				"connectionName": {},
				"connectionState": {},
				"region": {},
				"location": {},
				"bandwidth": {},
				"vlan": {
					"type": "integer"
				},
				"partnerName": {},
				"loaIssueTime": {
					"type": "timestamp"
				},
				"lagId": {},
				"awsDevice": {}
			}
		},
		"Sp": {
			"type": "structure",
			"members": {
				"ownerAccount": {},
				"virtualInterfaceId": {},
				"location": {},
				"connectionId": {},
				"virtualInterfaceType": {},
				"virtualInterfaceName": {},
				"vlan": {
					"type": "integer"
				},
				"asn": {
					"type": "integer"
				},
				"authKey": {},
				"amazonAddress": {},
				"customerAddress": {},
				"addressFamily": {},
				"virtualInterfaceState": {},
				"customerRouterConfig": {},
				"virtualGatewayId": {},
				"routeFilterPrefixes": {
					"shape": "Sv"
				},
				"bgpPeers": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"asn": {
								"type": "integer"
							},
							"authKey": {},
							"addressFamily": {},
							"amazonAddress": {},
							"customerAddress": {},
							"bgpPeerState": {},
							"bgpStatus": {}
						}
					}
				}
			}
		},
		"Sv": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"cidr": {}
				}
			}
		},
		"S1j": {
			"type": "structure",
			"members": {
				"interconnectId": {},
				"interconnectName": {},
				"interconnectState": {},
				"region": {},
				"location": {},
				"bandwidth": {},
				"loaIssueTime": {
					"type": "timestamp"
				},
				"lagId": {},
				"awsDevice": {}
			}
		},
		"S1o": {
			"type": "structure",
			"members": {
				"connectionsBandwidth": {},
				"numberOfConnections": {
					"type": "integer"
				},
				"lagId": {},
				"ownerAccount": {},
				"lagName": {},
				"lagState": {},
				"location": {},
				"region": {},
				"minimumLinks": {
					"type": "integer"
				},
				"awsDevice": {},
				"connections": {
					"shape": "S1q"
				},
				"allowsHostedConnections": {
					"type": "boolean"
				}
			}
		},
		"S1q": {
			"type": "list",
			"member": {
				"shape": "S7"
			}
		},
		"S28": {
			"type": "structure",
			"members": {
				"loaContent": {
					"type": "blob"
				},
				"loaContentType": {}
			}
		},
		"S2b": {
			"type": "structure",
			"members": {
				"connections": {
					"shape": "S1q"
				}
			}
		},
		"S2x": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"key"
				],
				"members": {
					"key": {},
					"value": {}
				}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/directconnect-2012-10-25.min.json
// module id = 1301
// module chunks = 0